var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27.6 28.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{filter:url(#Shadow_3);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_3",
    x: "-15%",
    y: "-15%",
    width: "140%",
    height: "130%",
    name: "Shadow_3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    result: "offsetBlurredAlpha",
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlurredAlpha"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.89,25.29A7.07,7.07,0,1,1,25,18.2,7,7,0,0,1,17.89,25.29Zm4.56-6.93A4.56,4.56,0,0,0,13.33,18a4.56,4.56,0,0,0,4.46,4.74A4.5,4.5,0,0,0,22.45,18.36Z",
    transform: "translate(-4.14 -4.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.93,10.9a1.63,1.63,0,0,1-1.67,1.66,1.71,1.71,0,0,1-1.68-1.67,1.67,1.67,0,0,1,1.69-1.65A1.62,1.62,0,0,1,26.93,10.9Z",
    transform: "translate(-4.14 -4.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.24,32.38H11.63a7.5,7.5,0,0,1-7.49-7.49V11.72a7.51,7.51,0,0,1,7.49-7.5H24.24a7.51,7.51,0,0,1,7.5,7.5V24.89A7.5,7.5,0,0,1,24.24,32.38ZM11.63,7.06A4.66,4.66,0,0,0,7,11.72V24.89a4.66,4.66,0,0,0,4.65,4.66H24.24a4.66,4.66,0,0,0,4.66-4.66V11.72a4.66,4.66,0,0,0-4.66-4.66Z",
    transform: "translate(-4.14 -4.22)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagramIcon);
export default __webpack_public_path__ + "static/media/footerInstagramIcon.7b8f1a2e1156d8c6e40cccd036003151.svg";
export { ForwardRef as ReactComponent };